import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import styles from '@features/cms/components/categories/CategoryTilesBlock/CategoryTilesBlock.styles';
import { ICategoryTilesBlock } from '@features/cms/typescript';
import SingleTile from '@features/cms/components/categories/CategoryTilesBlock/components/SingleTile/SingleTile';
import { TServiceMap } from '@features/categories';
import { getServiceMap } from '@features/cms/components/categories/CategoryTilesBlock/services/getServiceMap';
import { TLocale } from '@typescript/index';
import SkeletonTile from '@features/cms/components/categories/CategoryTilesBlock/components/SkeletonTile/SkeletonTile';
import theme from '@styles/theme';
type PropsType = {
  data: ICategoryTilesBlock;
  defaultBackground?: string;
};
const CategoryTilesBlock = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite
}: PropsType) => {
  const {
    locale
  } = useRouter();
  const [serviceMap, setServiceMap] = useState<TServiceMap | null>(null);
  const {
    code,
    background,
    marginTop,
    marginBottom,
    tiles
  } = data;
  useEffect(() => {
    const fetchServiceMap = async () => {
      const serviceMapFetch = await getServiceMap(locale as TLocale);
      setServiceMap(serviceMapFetch);
    };
    fetchServiceMap();
  }, [data]);
  if (!serviceMap) return <div sx={styles.container(background || defaultBackground, marginTop, marginBottom)} data-testid="CategoryTilesBlock">
        <div sx={styles.tilesContainer}>
          {tiles.map(tile => <SkeletonTile key={tile.code} />)}
        </div>
      </div>;
  return <section id={code} sx={styles.container(background, marginTop, marginBottom)} data-testid={code}>
      <div sx={styles.tilesContainer} data-testid="CategoryTilesBlock-tilesContainer">
        {tiles.map(tile => <SingleTile key={`${tile.type}_${tile.code}`} tile={tile} serviceMap={serviceMap} />)}
      </div>
    </section>;
};
export default CategoryTilesBlock;